<template>
    <CardRh :processando="processando">
        <div class="disciplina-segunda-chamada-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-2">
                        <label for="pelotaoSegundaChamada" class="form-label">Pelotao</label>
                        <input id="pelotaoSegundaChamada" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pelotao" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="dataSolicitacaoSegundaChamada" class="form-label">Data Solicitacao</label>
                        <input id="dataSolicitacaoSegundaChamada" v-model="dataSolicitacao" @keyup="apertouEnter"
                            @blur="refreshTable" type="date" class="form-control form-control-solid" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3" v-if="status">
                        <label for="statusSegundaChamada" class="form-label">Status</label>
                        <Multiselect id="statusSegundaChamada" v-model="status_id" :options="status_select"
                            :searchable="true" @change="refreshTable" />
                    </div>

                    <div class="col-12 col-lg-4 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                        <button v-if="hasPermissaoEditar" type="button"
                            class="btn btn-sm btn-pmes-primary" title="Cadastrar" data-bs-toggle="modal"
                            :data-bs-target="'#' + modal_cadastro">
                            <span class="fs-6">Cadastrar</span>
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada($event)"
                    :pesquisar="false">
                    <th>Aluno</th>
                    <th>Pelotao</th>
                    <th>Data Avaliacao</th>
                    <th>Data Solicitacao</th>
                    <th>Status</th>
                    <th>Justificativa</th>
                    <th>Parecer</th>
                    <th style="min-width:140px" class="text-center" v-if="hasPermissaoEditar">Acoes</th>
                </KDataTable>
            </section>
        </div>

        <Cadastro :disciplina="disciplina" @segunda-chamada-criada="modeloAlterado" :modal="modal_cadastro"
            :perfis="perfis" v-if="hasPermissaoEditar" />
        <Editar :disciplina="disciplina" :modelo="dados" :modal="modal_atualizar"
            @segunda-chamada-alterada="modeloAlterado" :perfis="perfis" v-if="hasPermissaoEditar" />
    </CardRh>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CardRh from "@/components/cards/ManzaCard.vue";
import SegundaChamadaService from "@/service/v1/sigap/SegundaChamadaService";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";
import Cadastro from "./_Cadastro.vue";
import Editar from "./_Editar.vue";
import { Prop } from 'vue-property-decorator';
import Multiselect from '@vueform/multiselect';

@Options({
    name: "DisciplinaSegundaChamadaIndex",
    components: { Multiselect, CardRh, KDataTable, Cadastro, Editar },
})
export default class DisciplinaSegundaChamadaIndex extends Vue {
    @Prop() readonly disciplina!: any;
    @Prop() readonly modal_cadastro!: any;
    @Prop() readonly perfis!: any;

    public processando = false;
    public reloadDatatable = false;
    public config: any = null;
    public service = new SegundaChamadaService();
    public dados: any = null;
    public modal_atualizar = 'kt_atualizar_disciplina_segunda_chamada';

    public status_id: any = null;
    public status: any = null;
    public disciplinaId: any = null;
    public pelotao = '';
    public dataSolicitacao: any = null;

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE, PerfilConfig.LeituraDE], this.perfis);
    }

    get hasPermissaoEditar(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    get status_select() {
        if (this.status) {
            return this.status.map((item) => {
                return { value: item.id, label: item.nome };
            });
        }
        return [];
    }

    public getStatus() {
        this.processando = true;
        this.service.getStatus()
            .then(response => {
                this.status = JSON.parse(JSON.stringify(response));
                this.processando = false;
            })
            .catch(() => {
                this.processando = false;
            });
    }

    public modeloAlterado() {
        this.reloadDatatable = !this.reloadDatatable;
        this.dados = null;
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.pelotao = '';
        this.dataSolicitacao = null;
        this.status_id = null;
        this.refreshTable();
    }

    created() {
        this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
        this.disciplinaId = this.$route.params.id;
        this.getStatus();

        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    disciplinaId: this.disciplinaId,
                    status: this.status_id,
                    pelotao: this.pelotao,
                    dataSolicitacao: this.dataSolicitacao,
                    search: d.search.value,
                };
                return dados;
            }
        };
        this.config.order = [[2, 'desc'],[3, 'desc']];
        this.config.columns = [
            { data: 'matricula.usuario.nome', name: 'matricula' },
            { data: 'matricula.pelotao', name: 'pelotao' },
            { data: 'dataAvaliacao', name: 'dataavaliacao', searchable: false },
            { data: 'dataSolicitacao', name: 'datasolicitacao', searchable: false },
            { data: 'status', name: 'status', searchable: false },
            { data: 'justificativa', name: 'justificativa' },
            { data: 'parecer', name: 'parecer' },
        ];

        this.config.columnDefs = [
            {
                targets: 2,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 3,
                render: (row) => {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 4,
                render: (row) => {
                    return row?.nome ? row.nome.replaceAll('_', ' ') : '';
                }
            }
        ];

        if (this.hasPermissaoEditar) {
            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push({
                targets: 7,
                render: (row, type, val) => {
                    let buttom = '';
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    return '<button class="btn btn-pmes-warning btn-sm" btn-editar-segunda-chamada ' + buttom + ' data-bs-toggle="modal" data-bs-target="#' +
                        this.modal_atualizar + '"><i class="fa fa-edit"></i></button>';
                },
            });
        }
    }

    public tableatualizada() {
        $('[btn-editar-segunda-chamada]').click((btn) => {
            this.dados = null;
            setTimeout(() => {
                this.dados = $(btn.currentTarget).data();
            }, 10);
        });
    }
}
</script>

<style scoped>
.disciplina-segunda-chamada-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
